import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDEhWRRti3XEo9lEsxSuZWt8_MR7Hl4HSo",
  authDomain: "canary-ai-app.firebaseapp.com",
  projectId: "canary-ai-app",
  storageBucket: "canary-ai-app.firebasestorage.app",
  messagingSenderId: "291143166241",
  appId: "1:291143166241:web:274b8f4e1e97e6116c3660",
  measurementId: "G-QPTPT0ZDXH",
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);

setPersistence(auth, browserLocalPersistence).catch(() => {
  // Ignore persistence errors (e.g. private mode)
});

export { app, auth, googleProvider, functions };
